var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.rowData),function(rowDatum){return _c('InformationRow',{key:rowDatum.name,attrs:{"rowDatum":rowDatum,"darken":_vm.darken}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }